import React from "react";
import { DEVELOPMENT_TYPE } from "Constants";

export var NO_SCHEDULE = "schedule";
export var NO_EXHIBITOR = "exhibitor";
export var NO_MAP = "maps";
export var NO_SPEAKER = "speaker";
export var NO_SPONSOR = "sponsor";
export var NO_MESSAGE = "message";
export var NO_EXHIBITOR_SEARCH = "exhibitor_search";
export var NO_NEWS = "news";
export var NO_SOCIAL_LINK = "social";
export var NO_USER = "user";
export var NO_CONFIRMED_USER = "user";
export var NO_WAITING_USER = "user";
export var NO_INACTIVE_USER = "user";
export var NO_COUPON = "coupon";
export var NO_ORDERS = "orders";
export var NO_POLL = "poll";
export var NO_PUBLISHED_QA = "liveqa_pub";
export var NO_UNPUBLISHED_QA = "liveqa_unpub";
export var NO_FORMLIST = "formbuilder";
export var NO_WEBSITERESPONSE = "websiteresponse";
export var NO_GALLERY = "gallery";
export var NO_POLLS = "polls";
export var NO_SURVEY = "survey";
export var NO_GAMIFICATION = "gamification";
export var NO_COMMUNITY = "community";
export var NO_ADVERTISEMENTS = "advertisement";
export var NO_EMAILLOGS = "emailog";
export var NO_QUIZ = "quiz";
export var NO_LEADER = "Leader";
export var NO_CHALLENGE = "Challenge";
export var NO_EVENTGUIDE = "event_guide";
export var NO_BILLING = "billings";
export var NO_SESSIONSCANED = "sessionscaned";
export var NO_SESSIONRSVP = "sessionrsvp";
export var NO_BADGEDESIGNER = "badgedesigner";
export var NO_SESSION_RATTING = "poll";

var NoContent = ({ contentType, connectFor }) => {
  var iconURL = `../../style/images/content-icons/content-${contentType}-Blank.png`;
  var message = "";
  var submessage = "";

  var imgStyle = {};

  if (connectFor === "table") {
    imgStyle.height = "100px";
  }

  switch (contentType) {
    case NO_SCHEDULE:
      message = "You have not added a schedule yet.";
      submessage = "Add a new schedule to show up on your Schedules List.";
      break;
    case NO_EXHIBITOR:
      message = "You have not added any exhibitor yet.";
      submessage =
        "Add a new exhibitor to show up on your Exhibitors List or modify your search.";
      break;
    case NO_MAP:
      message = "You have not added a map yet.";
      submessage = "Add a new map to show up on your Maps List.";
      break;
    case NO_SPEAKER:
      message =
        DEVELOPMENT_TYPE === "koachify"
          ? "No instructor found"
          : "No speaker found";
      submessage =
        DEVELOPMENT_TYPE === "koachify"
          ? "Add a new instructor to show up on your Instructors List or modify your search."
          : "Add a new speaker to show up on your Speakers List or modify your search.";
      break;
    case NO_SPONSOR:
      message = "No sponsor found";
      submessage =
        "Add a new sponsor to show up on your Sponsors List or modify your search.";
      break;
    case NO_MESSAGE:
      message = "You have not added a message yet.";
      submessage = "Add a new message to show up on your Messages List.";
      break;
    case NO_EXHIBITOR_SEARCH:
      message = "No exhibitor found";
      submessage = "Please modify your search.";
      break;
    case NO_SOCIAL_LINK:
      message =
        DEVELOPMENT_TYPE === "koachify"
          ? "No activity link found"
          : "No social links found";
      submessage =
        DEVELOPMENT_TYPE === "koachify" ? (
          "Add new activity links to show up on"
        ) : (
          <div className="w-50 d-flex flex-column">
            {/* <span className="text-center text-wrap ">
              Add your social page's link or hashtag to show up on
            </span> */}
            {/* <span className="text-center text-wrap ">&</span> */}
            <span className="text-center text-wrap ">
              {/* Event own platform for social posting is also available in the app */}
              Event own platform for social posting is available in the app
            </span>
          </div>
        );
      break;
    case NO_NEWS:
      message = "No news found";
      submessage = "Add news links to show up on News List";
      break;
    case NO_USER:
      message = "No user(s) added";
      submessage = "Please add one to make it appear in the list";
      if (connectFor === "confirmed") {
        message = "No confirmed user(s)";
        submessage = "Please confirm some users to appear in the list";
      } else if (connectFor === "waitlist") {
        message = "No waiting user(s)";
        submessage = "You have no users in waiting list";
      } else if (connectFor === "inactive") {
        message = "No inactive user(s)";
        submessage = "You have no users in inactive list";
      } else {
        message = "No user(s) added";
        submessage = "Please add one to make it appear in the list";
      }
      break;
    case NO_COUPON:
      message = "No coupon(s) added";
      submessage = "Please add one to make it appear in the list";
      break;
    case NO_ORDERS:
      message = "No order(s) available";
      submessage = "Please make an order to appear in the list";
      break;
    case NO_POLL:
      message = "No poll(s) added";
      submessage = "Please add one to make it appear in the list";
      break;
    case NO_PUBLISHED_QA:
      message = "No published live QA(s) added";
      submessage = "Please add one to make it appear in the list";
      break;
    case NO_UNPUBLISHED_QA:
      message = "No unpublished live QA(s) added";
      submessage = "Please add one to make it appear in the list";
      break;
    case NO_FORMLIST:
      message = "No form added";
      submessage = "Please add one to make it appear in the list";
      break;
    case NO_WEBSITERESPONSE:
      message = "No website response received";
      submessage = "Please wait till anyone submit contact form";
      break;
    case NO_GALLERY:
      message = "No images added in gallery";
      submessage = "Please add one to make it appear in the list";
      break;
    case NO_POLLS:
      message = "Manage Polls";
      submessage =
        "Click on the below button to go to 'Polls & Live QA' section to add a new poll.";
      break;
    case NO_SURVEY:
      message = "No survey added";
      submessage = "Please add one to make it appear in the list";
      break;
    case NO_COMMUNITY:
      message = "Community Forum";
      submessage =
        "You can rearrange the community forum from side menu to display in app.";
      break;
    case NO_GAMIFICATION:
      message = "Manage Gamification";
      submessage =
        "Click on the below button to go to 'Gamification' section to manage gamification.";
      break;
    case NO_SESSIONSCANED:
      message = "Manage Session Scanning Analytics";
      submessage = "No record found!";
      break;
    case NO_SESSIONRSVP:
      message = "No record found!";
      submessage =
        "You will get the RSVP user list as soon as the RSVP has been done for any session";
      break;
    case NO_ADVERTISEMENTS:
      message = "You have not added the advertisements";
      submessage =
        "Add an advertisement to show up on your Advertisement List.";
      break;
    case NO_EMAILLOGS:
      message = "No Email Logs to show";
      submessage = "No logs found";
      break;
    case NO_QUIZ:
      message = "No quiz added";
      submessage = "Please add one to make it appear in the list.";
      break;
    case NO_LEADER:
      message = "No Leader Found";
      submessage = "Please add one to make it appear in the list.";
      break;
    case NO_CHALLENGE:
      message = "No Challenge Found";
      submessage = "Please add one to make it appear in the list.";
      break;
    case NO_EVENTGUIDE:
      message = "No Event Guide Found";
      submessage = "Please add one to make it appear in the list.";
      break;
    case NO_BILLING:
      message = "No Active users Found";
      submessage = "No quote or invoice created";
      break;
    case NO_BADGEDESIGNER:
      message = "No Badge Found";
      submessage = "Please add one to make it appear in the list.";
      break;
    case NO_SESSION_RATTING:
      message = "No Session Added";
      submessage = "Please add one to make it appear in the list.";
      break;
    default:
  }

  return (
    <div className="no-content-container">
      <div>
        <div className="custom-align-center">
          <img src={iconURL} style={imgStyle} alt="no-content-icon" />
        </div>
        {/* <div className="no-content-message">{message}</div> */}
        <div className="no-content-message">{submessage}</div>
      </div>
    </div>
  );
};

export default NoContent;
